module.exports = __webpack_public_path__ + "img/hr-red-pita-04.6bc573ae.png";